/* eslint-disable react-hooks/exhaustive-deps */
import { Modal } from "antd";

import { useAtom } from "jotai";
import React, { useEffect } from "react";
import styled from "styled-components";
import { getMyBestScore, setMyBestScore } from "../db";

import { endStateAtom, newStarCountAtom, scoreAtom } from "../jotai/game";
import { userAtom } from "../jotai/service";
import GoogleLoginButton from "./GoogleLoginButton";

import HomeButton from "./HomeButton";
import RetryButton from "./RetryButton";

const GameEndModal = () => {
  const [user] = useAtom(userAtom);
  const [endState] = useAtom(endStateAtom);
  const [score] = useAtom(scoreAtom);
  const [newStarCount] = useAtom(newStarCountAtom);

  useEffect(() => {
    if (endState && user?.uid) {
      // 로그인한 유저
      const asyncFunc = async () => {
        try {
          const info = await getMyBestScore(user);
          console.log(info);

          if (!info || (info && info.bestScore < score)) {
            await setMyBestScore(user, score, (info?.star || 0) + newStarCount);
          } else {
            await setMyBestScore(
              user,
              info.bestScore,
              (info.star || 0) + newStarCount
            );
          }

          console.log(info);
        } catch (err) {}
      };
      asyncFunc();
    } else if (endState && !user?.uid) {
      // 로그인 안한 유저
      localStorage.setItem("not-login-score", String(score));
    }
  }, [endState]);

  return (
    <Modal
      open={endState}
      closable={false}
      centered
      footer={(_, { OkBtn, CancelBtn }) => <></>}
    >
      <Content>
        <ScoreText>점수: {score}</ScoreText>
        <ScoreText>얻은 별: {newStarCount}</ScoreText>
        {!user?.uid && <GoogleLoginButton />}
        <ButtonWrapper>
          <HomeButton />
          <RetryButton />
        </ButtonWrapper>
      </Content>
    </Modal>
  );
};

export default GameEndModal;

const ScoreText = styled.div`
  font-size: 32px;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;

  gap: 10px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;
